import { ClientOverride } from './buildAuthConfiguration';

/**
 * Used for logging in as internal uses. In both local and production environments
 * You can look up the internal access client here: https://access.cimpress.io/access-management/clients/dFzz8qvA9epUe28InBJYrBE4U8RuuVzQ
 */
export const INTERNAL_ACCESS_CLIENT: ClientOverride = {
    options: {
        connection: 'vistaprintcom-waad',
    },
    developmentMode: {
        clientID: 'dFzz8qvA9epUe28InBJYrBE4U8RuuVzQ', // This is not a secret, you can find it in the access client URL above.
        ...(process.env.NODE_ENV === 'development'
            ? {
                  redirectUriOrigin:
                      typeof window !== 'undefined' ? window.location.origin : undefined,
              }
            : {
                  // Only set redirectUriOrigin on vista based domains. /auth-callback/ doesn't
                  // register when redirecting on localhost.
                  redirectUriOrigin:
                      typeof window !== 'undefined'
                          ? `${window.location.origin}/auth-callback/`
                          : undefined,
              }),
    },
};
